import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

//helpers:
import {useTranslation} from "react-i18next";
import {isSupportedLanguage} from "../../../../i18n/index";

//components:
import {Dropdown} from "react-bootstrap";
import ReplayIcon from '@material-ui/icons/Replay';

//actions:
import {CustomTooltip} from "../../../widgets";

const RetryProcessDropdown = ({handleRetryAll, handleRetryFailed}) => {
    const {t, i18n} = useTranslation();

    //redux:
    //actions:

    return (
        <CustomTooltip
            config={{
                text: t("ADMINPANEL.UPLOAD.TABLE.RETRY_DROPDOWN"),
                placement: "top",
            }}
        >
            <Dropdown className="d-flex">
                <Dropdown.Toggle className="btn btn-light my-auto h-100 w-100">
                    <ReplayIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu className="header_menu_list">
                    <span className="dropdown-item elipsis_1line" onClick={handleRetryAll} active={0}>
                        {t("ADMINPANEL.UPLOAD.TABLE.RETRY_ALL_STEPS")}
                    </span>
                    <span className="dropdown-item elipsis_1line" onClick={handleRetryFailed} active={0}>
                        {t("ADMINPANEL.UPLOAD.TABLE.RETRY_FAILED_STEPS")}
                    </span>
                </Dropdown.Menu>
            </Dropdown>
        </CustomTooltip>
    );
};

export default RetryProcessDropdown;
